module.exports = __webpack_public_path__ + "static/media/posicionConsolidada.4984cded.svg";